import { RedoPrintJobSchema } from "@redotech/redo-model/fulfillments/print-job";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const PrintQueueStatusSchema = z.object({
  total: z.number(),
  completed: z.number(),
  failed: z.array(RedoPrintJobSchema),
  inFlight: z.array(RedoPrintJobSchema),
  activeJob: RedoPrintJobSchema.nullish(),
});

export type PrintQueueStatus = z.infer<typeof PrintQueueStatusSchema>;

const emptyPrintQueueMock = {
  total: 0,
  completed: 0,
  failed: [],
  inFlight: [],
  activeJob: null,
};

export const watchPrintQueue = unaryStreamRpc({
  name: "watchPrintQueue",
  input: z.object({}),
  output: PrintQueueStatusSchema,
  mock: emptyPrintQueueMock,
});
